import {
  TProductIntroProps,
  TProductIntroFields,
} from "../types/ProductIntro.types";
import mock from "../../../mocks/ProductIntro.mock";

export class ProductIntroModel {
  private readonly fields: null | TProductIntroFields;

  constructor(props: TProductIntroProps) {
    this.fields = props.fields || null;
  }

  get title(): string {
    return this.fields?.apiData?.title ?? mock.fields.apiData.title;
  }

  get description(): string {
    return this.fields?.apiData?.description ?? mock.fields.apiData.description;
  }

  get image(): string {
    return this.fields?.apiData?.full ?? mock.fields.apiData.full;
  }

  get imageAlt(): string {
    return (this.fields?.apiData?.fullAlt ?? mock?.fields?.apiData?.fullAlt) ?? '';
  }
}
